export const vi = {
  common: {
    save: 'Lưu',
    cancel: 'Huỷ',
    edit: 'Sửa',
    retry: 'Thử lại',
    saved: 'Đã lưu',
    loadError: 'Không tải được dữ liệu',
    search: 'Tìm kiếm…',
    columns: 'Cột',
    export: 'Xuất CSV',
    selected: 'Đã chọn {{count}}',
    month: 'Tháng {{month}}',
    previousMonth: 'Tháng trước',
    nextMonth: 'Tháng sau',
    none: '—',
    unassigned: 'Chưa thuộc đơn vị',
    noManager: 'Chưa có QLK',
  },
  status: { active: 'Đang hoạt động', paused: 'Tạm dừng', archived: 'Lưu trữ' },
  minimum: {
    met: 'Đạt mốc',
    on_track: 'Đúng tiến độ',
    behind: 'Chậm tiến độ',
    missed: 'Không đạt',
  },
  overview: {
    title: 'Tổng quan tháng',
    description: 'Doanh thu sau chia sẻ (SCS) theo người quản lý kênh và theo kênh.',
    net: 'Doanh thu SCS',
    gross: 'Trước chia sẻ: {{amount}}',
    target: 'Mục tiêu công ty',
    noTarget: 'Chưa đặt mục tiêu',
    achieved: '{{percent}} mục tiêu',
    partial: 'Bạn đang xem phạm vi được phân quyền, không phải toàn công ty.',
    belowMinimum: 'QLK chưa đạt mốc',
    belowMinimumHint: 'Mốc tối thiểu {{amount}}/tháng',
    progress: 'Ngày {{elapsed}}/{{days}}',
    closed: 'Đã chốt',
    topManagers: 'Người quản lý kênh (QLK)',
    topChannels: 'Kênh',
    topShare: 'Top 10 kênh chiếm {{percent}} doanh thu',
    rank: 'Hạng',
    code: 'Mã NV',
    manager: 'QLK',
    unit: 'Đơn vị',
    channels: 'Số kênh',
    expected: 'Cần đạt tới nay',
    forecast: 'Dự báo cuối tháng',
    status: 'Mốc tối thiểu',
    channel: 'Kênh',
    share: 'Tỷ trọng',
    noData: 'Chưa có doanh thu trong tháng này',
    missingTitle: '{{count}} kênh chưa nhập số liệu hôm qua',
    lastEntry: 'lần nhập gần nhất {{date}}',
    neverEntered: 'chưa nhập lần nào',
  },
  widgets: {
    details: 'Xem chi tiết',
    enter: 'Nhập ngay',
    channels: 'Danh sách kênh',
    gross: 'Trước chia sẻ {{amount}}',
    ofTarget: '{{percent}} mục tiêu {{amount}}',
    noTarget: 'Chưa đặt mục tiêu tháng',
    forecast: 'Dự báo cuối tháng {{amount}}',
    day: 'Ngày {{elapsed}}/{{days}}',
    behind: '{{count}}/{{total}} QLK chưa đạt mốc {{amount}}',
    allMet: 'Tất cả QLK đang đạt tiến độ mốc {{amount}}',
    noManagers: 'Chưa có QLK nào có doanh thu tháng này',
    allEntered: 'Đã nhập đủ số liệu hôm qua',
    more: 'và {{count}} kênh khác',
    lastEntry: 'lần cuối {{date}}',
    neverEntered: 'chưa nhập lần nào',
    syncOk: '{{count}} kênh đồng bộ tự động, không có lỗi',
    syncNone: 'Chưa có kênh nào kết nối tự động',
    syncFailed: '{{count}} kênh cần kết nối lại',
    lastSync: 'đồng bộ lần cuối {{date}}',
  },
  entry: {
    title: 'Nhập doanh thu',
    description:
      'Nhập tổng doanh thu từ đầu tháng tới hôm nay (trước chia sẻ) của từng kênh, như trong YouTube Studio.',
    date: 'Ngày',
    allChannels: 'Tất cả kênh',
    myChannels: 'Kênh của tôi',
    channel: 'Kênh',
    previous: 'Tổng lần trước',
    previousOn: 'ngày {{date}}',
    firstOfMonth: 'Lần đầu trong tháng',
    mtd: 'Tổng từ đầu tháng',
    delta: 'DT từ lần trước',
    net: 'Sau chia sẻ',
    rate: 'Tỷ lệ',
    empty: 'Bạn chưa được giao kênh nào vào ngày này',
    closed: 'Tháng này đã chốt, không thể sửa số liệu.',
    outsideWindow: 'Chỉ được nhập hoặc sửa từ ngày {{date}} trở đi.',
    unsaved_one: '{{count}} kênh chưa lưu',
    unsaved_other: '{{count}} kênh chưa lưu',
    decreased: 'Thấp hơn lần trước — kiểm tra lại (YouTube có thể điều chỉnh giảm)',
    spike: 'Tăng bất thường so với trung bình ngày',
    pasteHint: 'Mẹo: dán cả cột số từ Excel/Sheets vào ô đầu tiên; Enter để xuống dòng.',
    remove: 'Xoá số của ngày này',
  },
  daily: {
    title: 'Doanh thu theo ngày',
    description: 'Doanh thu sau chia sẻ từng ngày và cộng dồn trong tháng.',
    groupBy: 'Nhóm theo',
    unit: 'Đơn vị',
    manager: 'QLK',
    channel: 'Kênh',
    perDay: 'DT ngày',
    cumulative: 'DT cộng dồn',
    trend: 'Biến động',
    total: 'Tổng',
    all: 'Toàn bộ',
    empty: 'Chưa có doanh thu trong tháng này',
  },
  channels: {
    title: 'Kênh',
    description: 'Danh sách kênh YouTube, người quản lý và tỷ lệ chia sẻ.',
    add: 'Thêm kênh',
    name: 'Tên kênh',
    youtubeId: 'Mã kênh YouTube',
    youtubeIdHint: 'Dạng UC…, dùng cho đồng bộ tự động sau này.',
    handle: 'Handle',
    network: 'Network',
    noNetwork: 'Chưa gắn Network',
    pickNetwork: 'Chọn Network…',
    rateFromNetwork: 'Theo Network',
    manager: 'QLK',
    rate: 'Tỷ lệ LICO nhận',
    rateHint:
      'Phần trăm LICO giữ lại sau khi chia với Network. Để trống: theo tỷ lệ mặc định của Network.',
    status: 'Trạng thái',
    lastEntry: 'Nhập gần nhất',
    note: 'Ghi chú',
    startDate: 'Áp dụng từ ngày',
    empty: 'Chưa có kênh nào',
    back: 'Danh sách kênh',
    managers: 'Lịch sử người quản lý',
    rates: 'Lịch sử tỷ lệ chia sẻ',
    transfer: 'Chuyển QLK',
    newManager: 'QLK mới',
    noManagerOption: 'Không có người quản lý',
    transferHint:
      'Doanh thu từ ngày áp dụng sẽ tính cho QLK mới. Các tháng đã chốt không thay đổi.',
    changeRate: 'Đổi tỷ lệ',
    rateChangeHint: 'Doanh thu từ ngày áp dụng sẽ được tính lại theo tỷ lệ mới.',
    current: 'hiện tại',
    from: 'Từ',
    to: 'Đến',
    pickPerson: 'Chọn người…',
    source: 'Nguồn số liệu',
    manual: 'Nhập tay',
    api: 'Tự động (API)',
  },
  settings: {
    title: 'Cài đặt & chốt tháng',
    description: 'Giá trị mặc định, mục tiêu từng tháng và chốt số liệu sau khi đối soát.',
    defaults: 'Mặc định',
    defaultRate: 'Tỷ lệ LICO nhận mặc định (%)',
    defaultMinimum: 'Mốc tối thiểu mỗi QLK / tháng (USD)',
    defaultTarget: 'Mục tiêu công ty / tháng (USD)',
    editWindow: 'Số ngày QLK được sửa lại',
    editWindowHint:
      'Ví dụ 7: được nhập hoặc sửa số của 7 ngày gần nhất. Kế toán không bị giới hạn.',
    timezone: 'Múi giờ tính "hôm nay"',
    months: 'Theo tháng',
    monthsHint: 'Để trống để dùng giá trị của tháng trước gần nhất có đặt, hoặc giá trị mặc định.',
    month: 'Tháng',
    target: 'Mục tiêu',
    minimum: 'Mốc tối thiểu',
    state: 'Trạng thái',
    open: 'Đang mở',
    closedBy: 'Đã chốt bởi {{name}}',
    close: 'Chốt tháng',
    reopen: 'Mở lại',
    closeConfirm:
      'Chốt tháng {{month}}? Sau khi chốt, không ai sửa được số liệu, tỷ lệ hay QLK của tháng này.',
    reopenConfirm: 'Mở lại tháng {{month}} để sửa số liệu?',
    inherit: 'kế thừa {{amount}}',
  },
  sync: {
    title: 'Kết nối YouTube',
    description:
      'Lấy doanh thu ước tính theo ngày trực tiếp từ YouTube, 2 lần/ngày (07:00 và 15:00). Cần đăng nhập tài khoản Google Chủ sở hữu (Owner) của kênh.',
    notConfigured:
      'Máy chủ chưa cấu hình đồng bộ tự động (xem docs/YOUTUBE_SYNC_SETUP.md). Kênh đang nhập tay.',
    connect: 'Kết nối YouTube',
    reconnect: 'Kết nối lại',
    syncNow: 'Đồng bộ ngay',
    disconnect: 'Ngắt kết nối',
    disconnectConfirm:
      'Ngắt kết nối {{name}} với YouTube? Số liệu đã lấy được giữ nguyên; từ nay kênh chuyển về nhập tay.',
    account: 'Tài khoản Google',
    youtubeChannel: 'Kênh trên YouTube',
    lastSynced: 'Đồng bộ lần cuối',
    latestDay: 'Có số đến ngày {{date}} (YouTube thường trễ 2–3 ngày)',
    never: 'Chưa đồng bộ',
    lastError: 'Lỗi gần nhất',
    status: { active: 'Đang đồng bộ', error: 'Lỗi đồng bộ', revoked: 'Mất quyền truy cập' },
    revokedHint:
      'Chủ kênh đã thu hồi quyền hoặc quyền đã hết hạn. Kênh đã chuyển về nhập tay; hãy kết nối lại.',
    synced: 'Đã đồng bộ',
    automatic: 'Tự động',
    manual: 'Nhập tay',
    fromYoutube: 'Tự động từ YouTube',
    result: {
      ok: 'Đã kết nối kênh với YouTube.',
      access_denied: 'Bạn đã huỷ cấp quyền trên Google.',
      invalid_state: 'Phiên kết nối đã hết hạn, hãy thử lại.',
      channel_mismatch: 'Tài khoản đã chọn không phải kênh này (mã kênh YouTube khác).',
      channel_in_use: 'Kênh YouTube này đã gắn với một kênh khác trên Portal.',
      google_error: 'Google từ chối yêu cầu. Kiểm tra kênh đã bật kiếm tiền và thử lại.',
    },
  },
  milestones: {
    title: 'Mốc doanh thu',
    description:
      'Mốc doanh thu ngày (trước chia sẻ) của từng kênh theo quý. Đạt mốc được thưởng và đề xuất mốc tiếp theo.',
    quarter: 'Quý {{quarter}}/{{year}}',
    previousQuarter: 'Quý trước',
    nextQuarter: 'Quý sau',
    channel: 'Kênh',
    manager: 'QLK',
    current: 'Mốc đang xét',
    reached: 'Đã đạt',
    level: 'Mốc {{level}}',
    perDay: '{{amount}}/ngày',
    noMilestone: 'Chưa đặt mốc',
    statuses: {
      pending: 'Chờ duyệt',
      active: 'Đang xét',
      reached: 'Đã đạt',
      rejected: 'Bị từ chối',
      cancelled: 'Đã huỷ',
    },
    countsFrom: 'Tính từ {{date}}',
    reachedOn: 'Đạt ngày {{date}}: {{amount}}',
    bonus: 'Thưởng {{amount}}',
    flagged: 'Số liệu ngày đạt đã bị sửa giảm dưới mốc',
    payment: 'Đề nghị {{number}}',
    paymentDraft: 'Đề nghị nháp',
    noPayment: 'Chưa có đề nghị thanh toán',
    task: 'Việc đề xuất',
    setStart: 'Đặt mốc đầu quý',
    editStart: 'Sửa mốc đầu quý',
    startHint: 'Mốc 1 xét từ ngày đầu quý. Sửa được khi chưa đạt.',
    propose: 'Đề xuất mốc tiếp',
    proposeTitle: 'Đề xuất mốc {{level}} – {{channel}}',
    proposeHint: 'Phải lớn hơn mốc vừa đạt ({{amount}}). Người duyệt mốc sẽ được báo.',
    amount: 'Mốc doanh thu ngày (USD)',
    note: 'Ghi chú',
    reason: 'Lý do từ chối',
    approve: 'Duyệt',
    reject: 'Từ chối',
    rejectTitle: 'Từ chối mốc {{level}} – {{channel}}',
    cancel: 'Huỷ mốc',
    cancelConfirm:
      'Huỷ mốc {{level}} ({{amount}}) của kênh {{channel}}? Kênh sẽ không được xét mốc này nữa.',
    proposedBy: '{{name}} đề xuất',
    decidedNote: 'Lý do: {{note}}',
    pendingTitle: 'Chờ bạn duyệt',
    pendingHint: 'Mốc mới được xét từ ngày duyệt.',
    history: 'Lịch sử',
    bonuses: 'Thưởng trong quý',
    bonusTotal: 'Tổng thưởng: {{amount}}',
    bonusRow: '{{count}} lần đạt',
    noBonus: 'Chưa có lần đạt mốc nào trong quý.',
    empty: 'Không có kênh nào trong phạm vi bạn được xem.',
    pastQuarter: 'Quý đã qua: chỉ xem lại.',
    settings: 'Thưởng mốc doanh thu',
    settingsHint: 'Người duyệt mốc tiếp theo và mức thưởng khi đạt mốc.',
    approvers: 'Người duyệt mốc',
    addApprover: 'Thêm người duyệt…',
    noApprover: 'Chưa có người duyệt: QLK chưa đề xuất mốc mới được.',
    threshold: 'Ngưỡng mốc (USD)',
    bonusSmall: 'Thưởng khi mốc dưới ngưỡng (đ)',
    bonusLarge: 'Thưởng khi mốc từ ngưỡng trở lên (đ)',
  },
  errors: {
    youtube: {
      month_closed: 'Tháng này đã chốt, không thể thay đổi.',
      month_not_finished: 'Chỉ chốt được tháng đã kết thúc.',
      edit_window_passed: 'Ngày này đã quá thời hạn được sửa. Hãy nhờ kế toán.',
      not_channel_manager: 'Bạn không quản lý kênh này vào ngày đó.',
      duplicate_channel: 'Tên kênh hoặc mã kênh YouTube đã tồn tại.',
      channel_synced: 'Kênh này lấy doanh thu tự động từ YouTube, không nhập tay được.',
      sync_disabled: 'Máy chủ chưa cấu hình đồng bộ YouTube.',
      milestone_quarter: 'Chỉ đặt mốc cho quý này hoặc quý sau.',
      milestone_started:
        'Kênh đã đạt hoặc đã có mốc tiếp theo trong quý, không sửa mốc đầu quý được.',
      no_milestone_approver: 'Chưa cài đặt người duyệt mốc. Hãy nhờ kế toán.',
      milestone_open: 'Kênh đang có mốc chờ duyệt hoặc đang xét.',
      milestone_not_reached: 'Kênh chưa đạt mốc nào trong quý.',
      milestone_too_low: 'Mốc mới phải lớn hơn mốc vừa đạt.',
      milestone_decided: 'Mốc này đã được duyệt hoặc từ chối.',
      milestone_quarter_over: 'Quý của mốc này đã kết thúc.',
      milestone_closed: 'Chỉ huỷ được mốc đang chờ duyệt hoặc đang xét.',
    },
    generic: 'Thao tác không thành công. Vui lòng thử lại.',
  },
};

export const en: typeof vi = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    retry: 'Retry',
    saved: 'Saved',
    loadError: 'Could not load data',
    search: 'Search…',
    columns: 'Columns',
    export: 'Export CSV',
    selected: '{{count}} selected',
    month: 'Month {{month}}',
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    none: '—',
    unassigned: 'No unit',
    noManager: 'No manager',
  },
  status: { active: 'Active', paused: 'Paused', archived: 'Archived' },
  minimum: { met: 'Met', on_track: 'On track', behind: 'Behind', missed: 'Missed' },
  overview: {
    title: 'Monthly overview',
    description: 'Revenue after sharing by channel manager and by channel.',
    net: 'Revenue after sharing',
    gross: 'Before sharing: {{amount}}',
    target: 'Company target',
    noTarget: 'No target set',
    achieved: '{{percent}} of target',
    partial: 'You are viewing your permitted scope, not the whole company.',
    belowMinimum: 'Managers below minimum',
    belowMinimumHint: 'Minimum {{amount}}/month',
    progress: 'Day {{elapsed}}/{{days}}',
    closed: 'Closed',
    topManagers: 'Channel managers',
    topChannels: 'Channels',
    topShare: 'Top 10 channels make {{percent}} of revenue',
    rank: 'Rank',
    code: 'Emp. code',
    manager: 'Manager',
    unit: 'Unit',
    channels: 'Channels',
    expected: 'Due so far',
    forecast: 'Month-end forecast',
    status: 'Minimum',
    channel: 'Channel',
    share: 'Share',
    noData: 'No revenue this month yet',
    missingTitle: '{{count}} channels have no figure for yesterday',
    lastEntry: 'last entry {{date}}',
    neverEntered: 'never entered',
  },
  widgets: {
    details: 'Details',
    enter: 'Enter now',
    channels: 'Channels',
    gross: 'Before sharing {{amount}}',
    ofTarget: '{{percent}} of the {{amount}} target',
    noTarget: 'No target set for this month',
    forecast: 'Month-end forecast {{amount}}',
    day: 'Day {{elapsed}}/{{days}}',
    behind: '{{count}}/{{total}} managers below the {{amount}} minimum',
    allMet: 'Every manager is on track for {{amount}}',
    noManagers: 'No manager has revenue this month yet',
    allEntered: 'Every figure for yesterday is in',
    more: 'and {{count}} more',
    lastEntry: 'last {{date}}',
    neverEntered: 'never entered',
    syncOk: '{{count}} channels synced automatically, no errors',
    syncNone: 'No channel is connected for automatic sync',
    syncFailed: '{{count}} channels need to reconnect',
    lastSync: 'last synced {{date}}',
  },
  entry: {
    title: 'Enter revenue',
    description:
      'Enter each channel’s month-to-date revenue (before sharing), as shown in YouTube Studio.',
    date: 'Day',
    allChannels: 'All channels',
    myChannels: 'My channels',
    channel: 'Channel',
    previous: 'Previous total',
    previousOn: 'on {{date}}',
    firstOfMonth: 'First entry this month',
    mtd: 'Month-to-date total',
    delta: 'Since last entry',
    net: 'After sharing',
    rate: 'Rate',
    empty: 'No channel is assigned to you on this day',
    closed: 'This month is closed; figures cannot change.',
    outsideWindow: 'You can only enter or correct figures from {{date}} on.',
    unsaved_one: '{{count}} channel not saved',
    unsaved_other: '{{count}} channels not saved',
    decreased: 'Lower than the previous total — please check (YouTube may revise down)',
    spike: 'Unusually high compared with the daily average',
    pasteHint: 'Tip: paste a whole column from Excel/Sheets into the first box; Enter moves down.',
    remove: 'Remove this day’s figure',
  },
  daily: {
    title: 'Daily revenue',
    description: 'Revenue after sharing per day and month-to-date.',
    groupBy: 'Group by',
    unit: 'Unit',
    manager: 'Manager',
    channel: 'Channel',
    perDay: 'Daily',
    cumulative: 'Cumulative',
    trend: 'Trend',
    total: 'Total',
    all: 'All',
    empty: 'No revenue this month yet',
  },
  channels: {
    title: 'Channels',
    description: 'YouTube channels, their managers and share rates.',
    add: 'Add channel',
    name: 'Channel name',
    youtubeId: 'YouTube channel id',
    youtubeIdHint: 'Starts with UC…; used by automatic sync later.',
    handle: 'Handle',
    network: 'Network',
    noNetwork: 'No network',
    pickNetwork: 'Pick a network…',
    rateFromNetwork: 'From the network',
    manager: 'Manager',
    rate: 'LICO share',
    rateHint: 'Share LICO keeps after the network. Empty: the network default rate.',
    status: 'Status',
    lastEntry: 'Last entry',
    note: 'Note',
    startDate: 'Effective from',
    empty: 'No channels yet',
    back: 'Channels',
    managers: 'Manager history',
    rates: 'Share rate history',
    transfer: 'Change manager',
    newManager: 'New manager',
    noManagerOption: 'No manager',
    transferHint:
      'Revenue from the effective day is booked to the new manager. Closed months do not change.',
    changeRate: 'Change rate',
    rateChangeHint: 'Revenue from the effective day is recalculated with the new rate.',
    current: 'current',
    from: 'From',
    to: 'To',
    pickPerson: 'Pick a person…',
    source: 'Data source',
    manual: 'Manual entry',
    api: 'Automatic (API)',
  },
  settings: {
    title: 'Settings & closing',
    description: 'Defaults, monthly targets and closing figures after reconciliation.',
    defaults: 'Defaults',
    defaultRate: 'Default LICO share (%)',
    defaultMinimum: 'Minimum per manager / month (USD)',
    defaultTarget: 'Company target / month (USD)',
    editWindow: 'Days a manager may correct',
    editWindowHint:
      'E.g. 7: figures of the last 7 days can be entered or corrected. Accountants are not limited.',
    timezone: 'Time zone for "today"',
    months: 'Per month',
    monthsHint: 'Leave empty to use the latest earlier month that sets it, or the default.',
    month: 'Month',
    target: 'Target',
    minimum: 'Minimum',
    state: 'State',
    open: 'Open',
    closedBy: 'Closed by {{name}}',
    close: 'Close month',
    reopen: 'Reopen',
    closeConfirm: 'Close {{month}}? Once closed, nobody can change its figures, rates or managers.',
    reopenConfirm: 'Reopen {{month}} to change figures?',
    inherit: 'inherits {{amount}}',
  },
  sync: {
    title: 'YouTube connection',
    description:
      'Fetches estimated daily revenue straight from YouTube twice a day (07:00 and 15:00). Requires signing in with the channel’s Owner Google account.',
    notConfigured:
      'Automatic sync is not configured on the server (see docs/YOUTUBE_SYNC_SETUP.md). The channel uses manual entry.',
    connect: 'Connect YouTube',
    reconnect: 'Reconnect',
    syncNow: 'Sync now',
    disconnect: 'Disconnect',
    disconnectConfirm:
      'Disconnect {{name}} from YouTube? Fetched figures are kept; the channel goes back to manual entry.',
    account: 'Google account',
    youtubeChannel: 'YouTube channel',
    lastSynced: 'Last synced',
    latestDay: 'Figures up to {{date}} (YouTube usually lags 2–3 days)',
    never: 'Never',
    lastError: 'Last error',
    status: { active: 'Syncing', error: 'Sync error', revoked: 'Access lost' },
    revokedHint:
      'The owner revoked access or it expired. The channel is back on manual entry; reconnect it.',
    synced: 'Synced',
    automatic: 'Automatic',
    manual: 'Manual',
    fromYoutube: 'Automatic from YouTube',
    result: {
      ok: 'The channel is connected to YouTube.',
      access_denied: 'You cancelled the consent on Google.',
      invalid_state: 'The connection attempt expired; try again.',
      channel_mismatch:
        'The account you picked is not this channel (different YouTube channel id).',
      channel_in_use: 'This YouTube channel is already linked to another Portal channel.',
      google_error: 'Google refused the request. Check the channel is monetised and try again.',
    },
  },
  milestones: {
    title: 'Revenue milestones',
    description:
      'Daily revenue milestones (before sharing) per channel and quarter. Reaching one earns a bonus and a proposal for the next.',
    quarter: 'Q{{quarter}} {{year}}',
    previousQuarter: 'Previous quarter',
    nextQuarter: 'Next quarter',
    channel: 'Channel',
    manager: 'Manager',
    current: 'Current milestone',
    reached: 'Reached',
    level: 'Milestone {{level}}',
    perDay: '{{amount}}/day',
    noMilestone: 'No milestone',
    statuses: {
      pending: 'Awaiting approval',
      active: 'Counting',
      reached: 'Reached',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
    },
    countsFrom: 'Counts from {{date}}',
    reachedOn: 'Reached on {{date}}: {{amount}}',
    bonus: 'Bonus {{amount}}',
    flagged: 'The reaching day was revised below the milestone',
    payment: 'Request {{number}}',
    paymentDraft: 'Draft request',
    noPayment: 'No payment request yet',
    task: 'Proposal task',
    setStart: 'Set starting milestone',
    editStart: 'Edit starting milestone',
    startHint: 'Milestone 1 counts from the first day of the quarter. Editable until reached.',
    propose: 'Propose next',
    proposeTitle: 'Propose milestone {{level}} – {{channel}}',
    proposeHint:
      'Must be above the milestone just reached ({{amount}}). The approvers are notified.',
    amount: 'Daily revenue milestone (USD)',
    note: 'Note',
    reason: 'Reason',
    approve: 'Approve',
    reject: 'Reject',
    rejectTitle: 'Reject milestone {{level}} – {{channel}}',
    cancel: 'Cancel milestone',
    cancelConfirm:
      'Cancel milestone {{level}} ({{amount}}) of {{channel}}? It will no longer be counted.',
    proposedBy: 'Proposed by {{name}}',
    decidedNote: 'Reason: {{note}}',
    pendingTitle: 'Waiting for your approval',
    pendingHint: 'An approved milestone counts from the day of approval.',
    history: 'History',
    bonuses: 'Bonuses this quarter',
    bonusTotal: 'Total: {{amount}}',
    bonusRow: '{{count}} reached',
    noBonus: 'No milestone reached this quarter yet.',
    empty: 'No channel in your scope.',
    pastQuarter: 'Past quarter: read only.',
    settings: 'Revenue milestone bonus',
    settingsHint: 'Who approves the next milestones and the bonus amounts.',
    approvers: 'Milestone approvers',
    addApprover: 'Add an approver…',
    noApprover: 'No approver: managers cannot propose new milestones yet.',
    threshold: 'Threshold (USD)',
    bonusSmall: 'Bonus below the threshold (VND)',
    bonusLarge: 'Bonus from the threshold (VND)',
  },
  errors: {
    youtube: {
      month_closed: 'This month is closed and cannot change.',
      month_not_finished: 'Only finished months can be closed.',
      edit_window_passed: 'This day can no longer be edited. Ask an accountant.',
      not_channel_manager: 'You do not manage this channel on that day.',
      duplicate_channel: 'The channel name or YouTube id already exists.',
      channel_synced:
        'This channel’s revenue comes from YouTube automatically and cannot be entered by hand.',
      sync_disabled: 'YouTube sync is not configured on the server.',
      milestone_quarter: 'Milestones are set for this quarter or the next.',
      milestone_started:
        'The channel already reached or replaced its first milestone this quarter.',
      no_milestone_approver: 'No milestone approver is set. Ask accounting.',
      milestone_open: 'The channel already has a milestone awaiting approval or counting.',
      milestone_not_reached: 'The channel has not reached a milestone this quarter.',
      milestone_too_low: 'The next milestone must be above the last one.',
      milestone_decided: 'This milestone was already decided.',
      milestone_quarter_over: 'The quarter of this milestone is over.',
      milestone_closed: 'Only open milestones can be cancelled.',
    },
    generic: 'The action failed. Please try again.',
  },
};
